export default [
  {
    id: 'sourceSansPro',
    label: 'Source Sans Pro',
    value: '"Source Sans Pro", sans-serif'
  },
  {
    id: 'sourceSerifPro',
    label: 'Source Serif Pro',
    value: '"Source Serif Pro", serif'
  }
];
